/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const en_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const es_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ofrecer mis plazas libres`
};

const fr_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Conduisez malin`
};

const it_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const nl_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

const pt_routeresults__blablacar_card__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return ``
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.routeresults__blablacar_card__cta_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("routeresults__blablacar_card__cta_label", locale)
	if (locale === "de") return de_routeresults__blablacar_card__cta_label(inputs)
	if (locale === "en") return en_routeresults__blablacar_card__cta_label(inputs)
	if (locale === "es") return es_routeresults__blablacar_card__cta_label(inputs)
	if (locale === "fr") return fr_routeresults__blablacar_card__cta_label(inputs)
	if (locale === "it") return it_routeresults__blablacar_card__cta_label(inputs)
	if (locale === "nl") return nl_routeresults__blablacar_card__cta_label(inputs)
	return pt_routeresults__blablacar_card__cta_label(inputs)
};